<template>
  <div>
    <div class="card rounded-top-0 rounded-bottom-4 border-0">
      <form
          class="card-body text-center p-4"
          @submit.prevent="search"
      >
        <HtmlText v-if="!inPosMode()" tag="h1" :text="$t('heading')" class="mt-3 mb-4"></HtmlText>

        <p v-if="!inPosMode()" class="pt-1 pb-4">
          {{ $t('introduction') }}
        </p>

        <error-list class="mb-3"></error-list>

        <div v-if="posLoading">
                  <span
                      class="spinner-border"
                      role="status"
                      aria-hidden="true">
                  </span>
        </div>
        <div v-else-if="!inPosMode()">
          <label
              for="code"
              class="visually-hidden"
          >
            {{ $t('code') }}
          </label>

          <input
              v-model="code"
              type="search"
              id="code"
              class="form-control"
              autocomplete="off"
              required
              :placeholder="$t('code event')"
          >

          <div class="d-grid gap-2 pt-4">
            <button
                type="submit"
                class="btn btn-success"
                :class="{ 'disabled': !code || code.length === 0 }"
                :disabled="!code || code.length === 0"
            >
              {{ $t('continue') }}
            </button>
          </div>
        </div>
        <div class="d-grid gap-2 pt-4" v-else>
          <button
              type="submit"
              class="btn btn-success"
              @click="fetchPos"
          >
            {{ $t('refresh') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import eventBus from '../eventBus';
import EventService from '../services/EventService';
import posMixin from '../mixins/posMixin';
import PosService from '../services/PosService';
import HtmlText from '../components/HtmlText';

export default {
  components: {
    HtmlText
  },

  mixins: [posMixin],

  props: [
    'posToken'
  ],

  data() {
    return {
      code: null,
      error: null,
      posLoading: false
    }
  },

  /**
   * Set pos token if presented and get pos.
   */
  created() {
    if (this.posToken) {
      this.setPosToken(this.posToken);
    }

    if (this.getPosToken()) {
      this.fetchPos();
    }
  },

  methods: {
    /**
     * Get pos and (try) to set event.
     */
    fetchPos() {
      this.posLoading = true;

      PosService.get(this.getPosToken()).then(response => {
        this.setPos(response.data);
        this.toEvent(response.data.event);
      }).catch(error => {
        if (error.response.data.message) {
          eventBus.$emit('error', error.response.data.message);
        }
      }).finally(() => {
        this.posLoading = false;
      });
    },

    /**
     * Search for an event by code.
     */
    search() {
      EventService.get(this.code).then(response => {
        const event = response.data.data;

        this.toEvent(event.code, event);
      }).catch(error => {
        if (error.response.status !== 404) {
          return;
        }

        if (error.response.data.message) {
          eventBus.$emit('error', error.response.data.message);
          return;
        }

        eventBus.$emit('error', this.$t('eventNotFound'));
      });
    },

    /**
     * Go to event.
     *
     * @param {String} code
     * @param {Object} [event]
     */
    toEvent(code, event) {
      this.$router.push({
        name: 'booking',
        params: {
          code: code,
          requestedEvent: event
        }
      });
    }
  }
}
</script>
